<!-- 检验记录 -->
<template>
  <div class="room-content">
    <!--分页列表 -->
    <div
      class="listBox"
      :class="{
        currentEnvironmentTrue: GLOBAL.currentEnvironment,
        currentEnvironmentFalse: !GLOBAL.currentEnvironment,
      }"
    >
      <pageList
        ref="pageList"
        :checkedShow="checkedShow"
        :operationTxt="operationTxt"
        :columns="columns"
        :usedGetMethods="true"
        :listUrl="listUrl"
        @getCheckedValue="getCheckedValue"
        @handleList="handleList"
        @operationItem="operationItem"
        :minLen="3"
      >
        <div class="rt-column" slot="body" slot-scope="{ item }">
          <div class="rt-row">
            <div class="column">
              <span class="column-t">不合格数：</span>
              <span class="column-c"
                ><span>{{ item.unqualifiedNum || 0 }}</span></span
              >
            </div>
          </div>

          <div class="rt-row">
            <div class="column">
              <span class="column-t">检验时间：</span>
              <span class="column-c">{{ item.inspectTime || "-" }}</span>
            </div>
          </div>

        </div>
        <div slot="label" slot-scope="{ item }" class="labelBox">
            <div
              class="labelLeft"
              :style="{
                color: orderStatusFn(item.status).color,
                backgroundColor: orderStatusFn(item.status).bcColor,
              }"
            >
              {{ item.statusText || "-" }}
            </div>
          </div>
      </pageList>
    </div>
  </div>
</template>
    <script>
import VanDropdownCheckbox from "@/views/workManagement/defectsDeal/VanDropdownCheckbox";
import Search from "@/components/search";
import SearchTag from "./SearchTag.vue";
import Navbar from "@/components/navBar/navBar_right";
import TabBar from "@/components/TabBar";
import pageList from "@/components/pageList";
import { basicProductionProcessesList, deleteTaskApi } from "@/api/mobile";
import ContactPickers from "@/components/choiceuse/ContactPickers";
import { produceOrderReportWorkDelete } from "@/api/productionApply";
import moment from "moment";
import { deleteAction } from "@/api/manage";
import { hasButton } from "@/utils/hasPermission";

export default {
  name: "carRoomList",
  components: {
    Navbar,
    TabBar,
    pageList,
    Search,
    SearchTag,
    VanDropdownCheckbox,
    ContactPickers,
  },
  data() {
    return {
      contactPickersIndex: 0,
      selecTwoKey: 0,
      selectTwoValue: [],
      itemInfo: {},
      createdByName1: "",
      ddthrVisible1: false,
      // 1
      minDate: new Date(),
      createEndMinDate: new Date(),
      createdTimeBeginVisible: false,
      createdTimeEndVisible: false,
      // 2
      minDate2: new Date(),
      createEndMinDate2: new Date(),
      createdTimeBeginVisible2: false,
      createdTimeEndVisible2: false,

      showDialog: false,
      dialogMessage: "",
      checkedShow: false, //列表是否支持选择
      operationTxt: "批量报工", //选择按钮名称
      listUrl: "/jksaas-produce/produce/quality/unqualified/list", //列表接口
      columns: {
        titleKey: "inspectByText", //标题
        //   subtitleKey: "serialName",
        // content: [
        //   //内容
        //   {
        //     name: "生产物品",
        //     key: ["orderCode"],
        //   },
        //   {
        //     name: "任务时间",
        //     key: ["processName"],
        //   },
        //   {
        //     name: "计划数",
        //     key: ["planProductionNum", "reportWorkUnitText"],
        //   },
        // ],
        // labelKey: ["orderStatusName", "reportStatusName"], //标签
        // operation: [
        //   //操作
        //   {
        //     name: "报工",
        //     icon: require("../../../assets/actionIcon/report.png"),
        //   },
        //   {
        //     name: "申请领料",
        //     icon: require("../../../assets/actionIcon/apply.png"),
        //   },
        //   {
        //     name: "申请补料",
        //     icon: require("../../../assets/actionIcon/apply.png"),
        //   },
        //   {
        //     name: "申请退料",
        //     icon: require("../../../assets/actionIcon/apply.png"),
        //   },
        //   {
        //     name: "删除",
        //     icon: require("../../../assets/actionIcon/delete.png"),
        //     color: "#FF4D4F",
        //   },
        // ],
      },
      keyword: "",
      dropdownObj: {
        orderId: this.$route.query.taskId,
        // processesIds: "",
        // reportStatus: "yes",
        // orderStatus: "",
      },
      messSingleProcessTaskStaticsDtoList: [
        {
          text: "待处理",
          value: "0",
        },
        {
          text: "已处理",
          value: "1",
        },
      ],
      //   selectValue: [],
      selecKey: 1,
      appTitle: "生产报工",
      currentEnvironment: "",
    };
  },
  computed: {},
  beforeRouteLeave(to, from, next) {
    if (this.$refs.SearchTag.showSearchTag) {
      this.appTitle = this.$route.query.navTitle;
      this.$refs.SearchTag.showSearchTag = false;
      next(false);
    } else if (this.checkedShow) {
      this.checkedShow = false;
      next(false);
    } else {
      this.appTitle = "生产报工";
      next();
    }
  },
  created() {
    console.log(this.$route.query, "9999");
    this.currentEnvironment = localStorage.getItem("currentEnvironment");
    this.appTitle = this.$route.query.navTitle || "生产报工";
    // this.getLeftData();
  },
  mounted() {
    let searchObj = {
      ...this.dropdownObj,
      keyword: this.keyword,
    };
    this.searchQuery(searchObj);
  },
  methods: {
    hasButton,
    //确定删除
    dialogConfirm() {
      deleteAction("/quality/inspectionRecord/deleteBatch", {
        ids: this.itemInfo.id,
      }).then((res) => {
        if (res.code == 200) {
          this.$toast("删除成功");
          let searchObj = {
            ...this.dropdownObj,
            keyword: this.keyword,
          };
          this.searchQuery(searchObj);
        } else {
          this.$toast("失败");
        }
      });
    },
    // 删除操作
    deleteItem(v) {
      this.itemInfo = v;
      // console.log(this.itemInfo.id,'==')
      this.showDialog = true;
    },
    // 编辑
    editFn(item) {
      this.$router.push({
        path: "/disqualificationTreatmentForm",
        query: {
          type: "edit",
          item,
        },
      });
    },
    // 新建
    goAdd() {
      if (hasButton("reportWork:add")) {
        this.$router.push({
          path: "/newReportForm",
          query: {
            type: 0,
          },
        });
      } else {
        this.$toast("暂无权限");
      }
    },
    // 操作人
    confirmDdtjr1(val, selectedList, judge) {
      this.dropdownObj.inspectReportBy = "";
      this.createdByName1 = "";
      if (judge) {
        this.ddthrVisible1 = false;
        return;
      }
      this.dropdownObj.inspectReportBy = val ? val : ""; //人员id
      let arr = [];
      if (selectedList) {
        selectedList.forEach((item) => {
          arr.push(item.realname);
        });
      }
      this.createdByName1 = arr.join(",");
      this.ddthrVisible1 = false;
      this.dropDownChang();
    },
    orderStatusFn(v) {
      if (v == 0) {
        return {
          text: "未开始",
          color: "#ff9900",
          bcColor: "#fff5e6",
        };
      } else if (v == 1) {
        return {
          text: "生产中",
          color: "#19BE6B",
          bcColor: "#E8F9F0",
        };
      } else if (v == 2) {
        return {
          text: "已完成",
          color: "#19BE6B",
          bcColor: "#E8F9F0",
        };
      } else if (v == 3) {
        return {
          text: "已取消",
          color: "#ff9900",
          bcColor: "#fff5e6",
        };
      } else {
        return {
          text: "-",
          color: "#ff9900",
          bcColor: "#fff5e6",
        };
      }
    },
    // 选择任务开始 => 开始时间
    confirmCreatedStartTime(date) {
      this.createEndMinDate = date;
      this.dropdownObj.startPlanStartTime = moment(date)
        .startOf("day")
        .format("YYYY-MM-DD");
      this.dropdownObj.endPlanStartTime = ""; // 切换开始时间后直接置空结束时间重新选择
      this.createdTimeBeginVisible = false;
      this.createdTimeEndVisible = true;
      this.createdTimeRead = moment(date).format("YYYY-MM-DD");
    },
    // 取消任务开始 => 开始时间
    cancelCreatedStartTime() {
      this.dropdownObj.startPlanStartTime = "";
      this.dropdownObj.endPlanStartTime = "";
      this.createdTimeRead = "";
      this.minDate = new Date();

      let searchObj = {
        ...this.dropdownObj,
        keyword: this.keyword,
      };
      this.searchQuery(searchObj);
      this.createdTimeBeginVisible = false;
    },
    // 选择任务结束 => 开始时间
    confirmCreatedEndTime(date) {
      this.dropdownObj.endPlanStartTime = moment(date)
        .endOf("day")
        .format("YYYY-MM-DD");
      this.createdTimeEndVisible = false;
      this.createdTimeRead =
        this.createdTimeRead + "~" + moment(date).format("YYYY-MM-DD");
      let searchObj = {
        ...this.dropdownObj,
        keyword: this.keyword,
      };
      this.searchQuery(searchObj);
    },
    // 取消任务结束 => 结束时间
    cancelCreatedEndTime() {
      this.dropdownObj.startPlanStartTime = "";
      this.dropdownObj.endPlanStartTime = "";
      this.createdTimeRead = "";
      this.minDate = new Date();
      let searchObj = {
        ...this.dropdownObj,
        keyword: this.keyword,
      };
      this.searchQuery(searchObj);
      this.createdTimeEndVisible = false;
    },
    // ================================
    typeChange(val) {
      console.log(val, "val");
      this.dropdownObj.status = val ? val.split(",") : [];
      this.selectTwoValue = val ? val.split(",") : [];
      this.selecTwoKey += 1;
      // this.dropdownObj.status = val
      this.dropDownChang();
    },
    // 选择任务结束 => 开始时间
    confirmCreatedStartTime2(date) {
      this.createEndMinDate2 = date;
      this.dropdownObj.inspectReportStartTime = moment(date)
        .startOf("day")
        .format("YYYY-MM-DD");
      this.dropdownObj.inspectReportEndTime = ""; // 切换开始时间后直接置空结束时间重新选择
      this.createdTimeBeginVisible2 = false;
      this.createdTimeEndVisible2 = true;
      this.createdTimeRead2 = moment(date).format("YYYY-MM-DD");
    },
    // 取消任务结束 => 开始时间
    cancelCreatedStartTime2() {
      this.dropdownObj.inspectReportStartTime = "";
      this.dropdownObj.inspectReportEndTime = "";
      this.createdTimeRead2 = "";
      this.minDate2 = new Date();

      let searchObj = {
        ...this.dropdownObj,
        keyword: this.keyword,
      };
      this.searchQuery(searchObj);
      this.createdTimeBeginVisible2 = false;
    },
    // 选择任务结束 => 开始时间
    confirmCreatedEndTime2(date) {
      this.dropdownObj.inspectReportEndTime = moment(date)
        .endOf("day")
        .format("YYYY-MM-DD");
      this.createdTimeEndVisible2 = false;
      this.createdTimeRead2 =
        this.createdTimeRead2 + "~" + moment(date).format("YYYY-MM-DD");
      let searchObj = {
        ...this.dropdownObj,
        keyword: this.keyword,
      };
      this.searchQuery(searchObj);
    },
    // 取消任务结束 => 结束时间
    cancelCreatedEndTime2() {
      this.dropdownObj.inspectReportStartTime = "";
      this.dropdownObj.inspectReportEndTime = "";
      this.createdTimeRead2 = "";
      this.minDate2 = new Date();
      let searchObj = {
        ...this.dropdownObj,
        keyword: this.keyword,
      };
      this.searchQuery(searchObj);
      this.createdTimeEndVisible2 = false;
    },
    // ================================
    checkColor(orderStatus) {
      let colorStr = "";
      switch (orderStatus) {
        case "notStarted":
          colorStr = "#ff943e";
          break;
        case "inProduction":
          colorStr = "#1890ff";
          break;
        case "completed":
          colorStr = "#00b042";
          break;
        case "abolished":
          colorStr = "#888888";
          break;
      }
      return colorStr;
    },

    clickAction(text) {
      if (text == "批量报工") {
        this.checkedShow = true;
      } else {
        this.checkedShow = false;
      }
    },
    // taskProcessChange(v) {
    //   this.selectTwoValue = v.split(",");
    //   this.selectTwoValue = this.selectTwoValue.filter((item) => item);
    //   this.dropdownObj.status = v;
    //   this.dropDownChang();
    //   this.selecKey += 1;
    // },
    dropDownChang() {
      let searchObj = {
        ...this.dropdownObj,
        keyword: this.keyword,
      };
      this.searchQuery(searchObj);
    },
    onSearch(v) {
      this.keyword = v;
      let searchObj = {
        ...this.dropdownObj,
        keyword: this.keyword,
      };
      this.searchQuery(searchObj);
    },
    onScreen() {
      this.appTitle = "更多筛选";
      this.keyword = this.$refs.topSearch.value;
      let pramsObj = JSON.parse(JSON.stringify(this.dropdownObj));
      pramsObj.keyword = this.keyword;
      this.$refs.SearchTag.showModal(this.keyword, pramsObj);
    },
    getCategory(sureObj) {
      //   console.log(sureObj,'sureObj')
      this.appTitle = this.$route.query.navTitle;
      this.keyword = sureObj.keyword;
      this.$refs.topSearch.value = sureObj.keyword;
      this.selectTwoValue = sureObj.status || [];
      //   this.createdByName1 = sureObj.status ? sureObj.status.split(","):[];
      //   console.log("看看这个人：", this.selectValue);
      this.dropdownObj = JSON.parse(JSON.stringify(sureObj));
      delete this.dropdownObj.keyword;
      this.searchQuery(sureObj);
    },
    // 获取选择的列表数据
    getCheckedValue(ids, selectArr) {
      if (selectArr.length > 0) {
        this.dialogMessage = "";
        let strArr = [];
        for (let item of selectArr) {
          if (item.reportStatus == "no") {
            let str = item.orderCode + "-" + item.processName;
            strArr.push(str);
          }
        }
        if (strArr.length > 0) {
          this.dialogMessage =
            "任务：" + strArr.join("、") + "，状态不对无法报工";
          this.showDialog = true;
        } else {
          this.checkedShow = false;
          this.$router.push({
            name: "productBatchReport",
            params: {
              selectArr: JSON.stringify(selectArr),
            },
          });
        }
      } else {
        this.$toast("请先选择数据");
      }
    },

    //列表点击更多按钮事件
    handleList(id, item, type) {
      if (type == "列表") {
        this.$router.push({
          path: "/disqualificationTreatmentDetail",
          query: {
            taskId: id,
            item,
          },
        });
      }
    },
    operationItem(item, type) {
      if (type == "报工") {
        this.$router.push({
          path: "/productTask/report",
          query: {
            taskId: item.id,
            orderId: item.orderId,
          },
        });
      }
      if (type == "删除") {
        this.confirmDelete(item);
      }
      if (type != "报工" && type != "删除") {
        this.applyAction(item, type);
      }
    },
    // 操作——删除
    confirmDelete(row) {
      let obj = {
        id: row.id,
      };
      deleteTaskApi(obj).then((res) => {
        if (res.success) {
          let searchObj = {
            ...this.dropdownObj,
            keywords: this.keywords,
          };
          this.searchQuery(searchObj);
          //   this.getLeftData();
          this.$toast("删除成功！");
        } else {
          this.$toast(res.message);
        }
      });
    },
    //操作——各种申请
    applyAction(row, type) {
      let str = "";
      if (type == "申请领料") {
        str = "/workManagement/materialRequisitionForm";
      } else if (type == "申请补料") {
        str = "/workManagement/addMaterialRequisitionForm";
      } else {
        str = "/workManagement/returnMaterial/returnMaterialForm";
      }
      if (str) {
        this.$router.push({
          path: str,
          query: {
            goodsBasicUnitText: row.goodsBasicUnitText,
            goodsName: row.goodsName,
            orderId: row.orderId,
          },
        });
      }
    },
    // 加载列表
    getList() {
      // 传1代表从第一页数据开始
      this.$refs.pageList.onLoad(1);
    },
    // 搜索
    searchQuery(searchObj) {
      let params = {
        ...searchObj,
        status: this.dropdownObj.status
          ? this.dropdownObj.status.join(",")
          : "",
        disposeMethod: this.dropdownObj.disposeMethod
          ? this.dropdownObj.disposeMethod.join(",")
          : "",
      };
      // console.log("这里有啥：", params);
      this.$refs.pageList.searchQuery(params);
    },
    // 重置
    searchReset() {
      this.$refs.pageList.searchReset();
    },
    goSearch() {
      this.$router.push({ path: "/carRoomPlaneSearch" });
    },
  },
};
</script>
    <style lang="scss" scoped>
/deep/ .van-overlay {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

.search {
  padding-top: 20px;
}

.rightText {
  margin-left: 20px;
}

.dropdown-menu1 {
  width: 33.3%;
}

.dropdown-menu2 {
  width: 33.3%;
}

.currentEnvironmentTrue {
  height: calc(100vh - 200px);
}

.currentEnvironmentFalse {
  height: calc(100vh - 300px);
}

.qualifiedNumColor {
  color: #19be6b;
}

.unqualifiedNumColor {
  color: #f56c6c;
}

.warningClass {
  margin-left: 14px;
}

.dialogMessageClass {
  margin: 20px 92px 60px 92px;
  color: #888888;
}

.dialogMessageBottomDidClass {
  background: #f0f0f0;
  width: 100%;
  height: 2px;
}

.delBtmBor {
  background: #f0f0f0;
  width: 100%;
  height: 2px;
}

.delcontent {
  margin: 20px 92px 60px 92px;
  color: #888888;
}

.delTitle {
  margin-left: 14px;
}

.operateBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  padding-right: 14px;
  font-size: 28px;
  font-weight: 500;
  color: #1890ff;
}

.pubBtn {
  margin-right: 24px;

  &:nth-last-child(1) {
    margin-right: 0;
  }
}

.rt-column {
  padding: 20px 0 0 20px;
  //  border: 1px solid red;
}

.rt-row {
  margin-bottom: 20px;

  .column {
    width: 100%;
    display: flex;

    .column-t {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #888888;
      // margin-bottom: 0.03rem;
    }

    .column-c {
      flex: 1;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #191f25;
      /* （超出限定的宽度就隐藏内容) */
      overflow: hidden;
      /* （设置文字在一行显示不能换行） */
      white-space: nowrap;
      /* （规定当文本溢出时显示省略符） */
      text-overflow: ellipsis;
    }
  }
}

.room-content-list {
  height: 60vh;
  overflow-y: scroll;

  .serach {
    height: 66px;
    background: #f2f2f6;
    border-radius: 0;
    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 66px;
    padding: 20px 24px;

    // border: 1px solid red;
    .placeh {
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #888888;
      line-height: 46px;
    }

    .icon {
      width: 30px;
      height: 32px;
    }
  }

  .serach-content {
    // height: 1.52rem;
    background: #ffffff;
    padding: 0 32px 32px 32px;

    .content {
      display: flex;

      .tapbtn {
        // height: 0.23rem;
        // background: #1890ff;
        background: #f2f2f6;
        border-radius: 4px;
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #888888;
        line-height: 46px;
        margin-right: 24px;
        text-align: center;
        padding: 8px 56px;
        cursor: pointer;
      }

      .active {
        color: #ffffff;
        background: #1890ff;
      }
    }
  }
}

.labelBox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 2px;

  .labelLeft {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f0f6fe;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 6px 20px;
    margin-right: 10px;
    font-size: 22px;
  }

  .labelRight {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f0f6fe;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 6px 14px;
    font-size: 22px;
  }
}

.listBox {
  height: calc(100vh - 300px);
  overflow-y: auto;
}

.dialogContentBox {
  text-align: left;
  margin: 20px 38px;
  color: #191f25;
  font-size: 32px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

/deep/ .van-dropdown-menu__bar {
  box-shadow: none;
}
</style>
